import React, { useState, useEffect } from "react";
import { sendData, getData } from "../../../services/auth";
import { uriList } from "../../../helpers/config";
import { Button } from "reactstrap";
import { Pagination, InputLabelAlert, DropDownMenu } from "../../../common/layout";
import { confirmSwal, swalError } from "../../../helpers/swal";
import { useSelector } from "react-redux";
import { width, generateId } from "../../../helpers";
import Tipos from './InclusaoTipos'
import { Aguarde, getCookie } from '../../../helpers/general'

const TiposDocumento = (props) => {
    const [allDocuments, setAllDocuments] = useState([]);
    const [tiposDocumento, setTiposDocumento] = useState([]);
    const [carregando, setCarregando] = useState(false)
    const [modal, setModal] = useState(false);
    const [data, setData] = useState({ id: 0, nome: "", tipo: "", categoria: "" });
    const [pesquisa, setPesquisa] = useState("")
    const [actualPage, setActualPage] = useState(0)
    const [qtdLinesPage, setQtdLinesPage] = useState(getCookie({ label: "qtdLinesPage" }) || 10)

    const _login = useSelector((state) => state.login);
    console.log("TiposDocumento._login: ", _login)

    async function _getData() {
        setCarregando(true)
        await sendData({ uri: uriList("tiposDocumento") })
            .then((_res) => {
                const res = _res.data || _res
                setCarregando(false)
                if (res) {
                    setTiposDocumento(res)
                    setAllDocuments(res)
                }
                console.log("Tipos de Documento: ", res);
            })
            .catch((e) => {
                setCarregando(false)
                console.log(e);
                // alert("Erro ao obter Tipos de Documento.\n" + e.message);
            });
    }

    useEffect(() => {
        _getData();
    }, []);

    async function closeModal(gravou) {
        setModal(false)
        if (gravou)
            await _getData();
    }

    async function handleDelete(element) {
        function callback(p) {
            if (p)
                sendData({ uri: uriList("tiposDocumentoDel"), content: { ...element, empresaid: _login.empresaid, usuarioid: _login.usuarioid } })
                    .then((res) => {
                        console.log("Tipos de Documento - Deletado: ", res);
                        if (res.status && parseInt(res.status) > 200) {
                            swalError({
                                title: `Erro ao excluir registro! \n${res.data || res.message || res.erro}`,
                            });
                            return
                        }

                        _getData();
                    }
                    )
        }

        confirmSwal({ callback, title: "Confirma a execução do processo?" });
    }


    function AddScreen() {
        return (
            <>

            </>)
    }

    function Incluir() {
        setModal(AddScreen());
    }

    function handlePesquisa(e) {
        let _value = e.target.value.toLowerCase()
        setPesquisa(e.target.value)
        if (_value) {
            console.log("Documentos.handlePesquisa:", _value)
            let _docs = allDocuments.filter(e =>
                e.CATEGORIA?.toLowerCase().indexOf(_value) >= 0 || e.NOME?.toLowerCase().indexOf(_value) >= 0 ||
                e.TIPO?.toLowerCase().indexOf(_value) >= 0
            )

            console.log("Documentos.handlePesquisa(docs):", _docs)
            setTiposDocumento(_docs)
        }
        else
            setTiposDocumento(allDocuments)

        setActualPage(0);
    }

    function handlePage(e) {
        setActualPage(e.currentTarget.value);
    }

    function handleEdit(e) {
        setModal(true)
        setData(e)
    }

    return (
        <div style={{height:"80vh", overflowY:"auto"}}>
            {modal && <Tipos empresaid={_login.empresaid} usuarioid={_login.usuarioid} onCloseEv={closeModal} data={data} tipos={allDocuments} />}
            <div
                style={{
                    flexDirection: width() == "mobile" ? "column" : "",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "10px",
                }}
            >
                <div className="col-md-12 mb-5">
                    <div className={`${width() == "mobile" ? "h3" : "h1"} center-elements`}>Tipos de Documento</div>
                </div>
                <div className="col-md-12 mb-3 d-flex justify-content-between">
                    <div className="col-3 d-flex align-items-center justify-content-left p-0">
                        <button className="btn btn-secondary"
                            onClick={e => {
                                if (props.onCloseEv)
                                    props?.onCloseEv()
                            }}

                        >
                            <i className="fa fa-window-close"></i>
                        </button>
                        {/* <button className="btn btn-secondary" onClick={() => {
                        if (props.onCloseEv)
                            props?.onCloseEv()
                    }}>Voltar</button> */}
                        <button className="btn btn-primary ml-1" onClick={() => {
                            Incluir()
                        }} disabled={carregando}>
                            <i className="fa fa-plus-circle"></i>
                        </button>
                        {/* <button className="btn btn-primary ml-1" onClick={() => {
                        setModal(true);
                    }} disabled={carregando}>Incluir</button> */}
                    </div>
                    <div className="col-5 p-0">
                        <div className="col-12 p-0">
                            <InputLabelAlert
                                type="text"
                                label="Pesquisa"
                                id="pesquisa"
                                cifrao={false}
                                value={pesquisa}
                                handle={handlePesquisa}
                                focus={true}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-md-12" style={{ overflow: "auto" }}>
                    <Pagination
                        detailed={tiposDocumento}
                        actual={actualPage}
                        changePage={handlePage}
                        setQtdLinesPage={setQtdLinesPage}
                    />
                    <div style={{ border: "0.1px solid #ccc", overflow: "auto" }}>
                        <table className="table table-striped table-hover mb-1 rounded" >
                            <thead className="thead-dark">
                                <tr>
                                    <th scope="col" style={{ width: "5%" }}>#</th>
                                    {/* <th scope="col" style={{ width: "5%" }}>ID</th> */}
                                    <th scope="col" style={{ width: "75%" }}>Nome</th>
                                    {/* <th scope="col" style={{ width: "10%" }}>Categoria</th> */}
                                    <th scope="col" style={{ width: "10%" }}>Tipo</th>
                                    <th
                                        scope="col"
                                        style={{ width: "10%" }}
                                        className="text-center"
                                    >
                                        Ações
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {!tiposDocumento && <tr>Carregando...</tr>}
                                {
                                    tiposDocumento?.map((tipo, index) => {
                                        return (<>
                                            {index >= actualPage * qtdLinesPage &&
                                                index < (actualPage + 1) * qtdLinesPage &&
                                                (

                                                    <tr onDoubleClick={e => handleEdit(tipo)} style={{ cursor: 'pointer' }}>
                                                        <th style={{ width: "5%" }}>{index + 1}</th>
                                                        {/* <td style={{ width: "5%" }}>{tipo.ID}</td> */}
                                                        <td style={{ width: "75%" }}>{tipo.NOME?.slice(0, 70)}</td>
                                                        {/* <td style={{ width: "10%" }}>{tipo.CATEGORIA}</td> */}
                                                        <td style={{ width: "10%" }}>{tipo.TIPO}</td>
                                                        <td style={{ width: "10%" }}>
                                                            <div className="d-flex justify-content-center ">
                                                                <DropDownMenu items={[
                                                                    { descricao: "Editar", onClick: e => handleEdit(tipo), className: "fa fa-edit", title: "Editar o Tipo de Documento" },
                                                                    { descricao: "Excluir", onClick: e => handleDelete(tipo), className: "fa fa-trash", title: "Excluir o Tipo de Documento", color: "red" },
                                                                ]} />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )}
                                        </>
                                        )
                                    })
                                }
                            </tbody>
                            <tr>
                                <td colSpan="12" className="text-left">
                                    Total de Registros: {tiposDocumento && tiposDocumento.length}
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
            {carregando && <Aguarde legenda="Aguarde, carregando registros..." />}
        </div>
    );
}

export default TiposDocumento;